export default "__VITE_ASSET__4u0I7$DD__"